import React, { useMemo, useRef } from 'react';
import { Button } from 'components/Button';
import { IOption } from 'components/Select/interface';
import './styles.scss';
import arrowDown from 'img/arrow-down-grey.svg';
import Text from 'components/Text';
import { useOutsideClick } from 'hooks/useOutsideClick';

interface MultiProfileHandler {
  title?: string;
  allItems: any;
  selected: string;
  width: string;
  className?: any;
  style?: any;
  show: boolean;
  setShow: any;
  setSelected: any;
}

const SelectNew: React.FC<MultiProfileHandler> = (props) => {
  const { allItems, selected, width, title, className, style, show, setShow, setSelected } = props;
  const wrapperRef = useRef(null);
  useOutsideClick(wrapperRef, setShow);


  const getItensList = useMemo(() => {
    if (allItems) {
      const _options: Array<IOption> = new Array<IOption>();

      Object.keys(allItems).forEach((key) => {
        _options.push({
          value: allItems[key].key,
          label: `${allItems[key].value}`,
        });

        return;
      });

      return _options;
    }
  }, [allItems]);

  const itemSelected = useMemo(() => {
    return selected;
  }, [selected]);

  const getSelected = () => {
    return (
      <Button
        className="color-black"
        onClick={() => setShow(!show)}
      >
        {itemSelected === '' || !itemSelected ? 'Selecione' : selected}
      </Button>
    );
  };

  const selectOptionDropdown = (label: string) => {
    setSelected(label);
    setShow(!show);
  };

  return (
    <div ref={wrapperRef} className={`align-center ajustment-row`}>
      {title && <Text className="mr-2 text-ajustment no-text-overflow">{title}</Text>}
      <div className={`selectGraphs-wrapper-ccare d-flex align-center pl-2 ${className}`} style={style}>
        {getSelected()}
        <a className={`arrow-down ${show && 'arrow-down-inverse'}`} onClick={() => setShow(!show)}>
          <img src={arrowDown} alt="" />
        </a>
        <ul
          className={
            show ? 'multiSelect-list multiSelect-list-ccare bg-white p-3'
              : 'multiSelect-list bg-white shadow-1 p-3 d-none'
          }
          style={{ minWidth: width }}
        >
          {getItensList?.map((opt, _key) => (
            <li className="multiSelect-item d-flex mb-2 mt-2" key={opt.label} onClick={() => selectOptionDropdown(opt.label)}>
              <label htmlFor={`cat-${opt.value}`}>{opt.label}</label>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default SelectNew;
